<div class="page-wrapper" [class]="className" [id]="id" >

  <div class="page-inner-wrapper" #innerWrapper>
    <div class="page-content" [ngClass]="contentClass">
      <ng-content></ng-content>
    </div>
    <ng-content select=[popup]></ng-content>
  </div>
</div>
